import React from "react";
import { Card, CardBody, CardTitle, Badge } from "reactstrap";
import { useLocation } from "react-router-dom";
import { Menu } from "../MenusTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faInfoCircle,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import { Table } from "react-bootstrap";
import { formatTimestamp } from "../../../../utility/Utility";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";

const MenuTableView: React.FC = () => {
  const location = useLocation();
  const { menu } = location.state as { menu: Menu };

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardBody>
          <CardTitle tag="h3" className="text-center mb-4">
            {menu.displayName}
          </CardTitle>
          <hr />
          <div className="Container-menu-view">
            <div className="menu-table-view">
              <table>
                <tbody className="menu-table-item">
                  <tr>
                    <th>Type</th>
                    <td>{menu.dineType}</td>
                  </tr>
                  <tr>
                    <th>
                      {" "}
                      <FontAwesomeIcon icon={faClock} /> Serving Time
                    </th>
                    <td>{menu.servingTime}</td>
                  </tr>
                  <tr>
                    <th>
                      {" "}
                      <FontAwesomeIcon icon={faInfoCircle} />
                      Status
                    </th>
                    <td>
                      {" "}
                      <Badge
                        color={
                          menu.status === "Approved" ? "success" : "secondary"
                        }
                      >
                        {menu.status}
                      </Badge>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      {" "}
                      <FontAwesomeIcon icon={faCalendarAlt} /> Created At
                    </th>
                    <td> {formatTimestamp(menu.createdAt)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <h5 className="mt-4">Items</h5>
          <Table bordered responsive className="mb-4">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Item Type</th>
                <th>Price (Rs.)</th>
                <th>Food Attributes</th>
                <th>Allergen Information</th>
              </tr>
            </thead>
            <tbody>
              {menu.items.map((item) => (
                <tr key={item.itemId}>
                  <td>{item.displayName}</td>
                  <td>{item.itemType.replace(/([a-z])([A-Z])/g, "$1 $2")}</td>
                  <td>Rs. {item.price.toFixed(2)}</td>
                  <td>
                    <div className="d-flex gap-2">
                      {item.foodAttributes?.length ? (
                        item.foodAttributes.map((attribute: any, i: any) => (
                          <img
                            key={i}
                            src={getImageUrl(attribute)}
                            alt={attribute}
                            width="24"
                            height="24"
                            title={attribute}
                          />
                        ))
                      ) : (
                        <span>None</span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex gap-2">
                      {item.allergenInformation?.length ? (
                        item.allergenInformation.map(
                          (attribute: any, i: any) => (
                            <img
                              key={i}
                              src={getImageUrl(attribute)}
                              alt={attribute}
                              width="24"
                              height="24"
                              title={attribute}
                            />
                          )
                        )
                      ) : (
                        <span>None</span>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default MenuTableView;
